import React from "react";
import ProviderWrap from "../utils/ProviderWrap";
import FlightTimeBlock from "./flight-time-block";

const FlightTimeWrapper = ({id, lang, widgetKey}) => {

  return <ProviderWrap
    paramId={id}
    lang={lang}
    link={`pricingblockapi/`}
  >
    <FlightTimeBlock widgetKey={widgetKey} />
  </ProviderWrap>

}

export default FlightTimeWrapper;
